/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateReportRequest } from '../models/CreateReportRequest';
import type { CreateReportResponse } from '../models/CreateReportResponse';
import type { ExportReportRequest } from '../models/ExportReportRequest';
import type { GetReportResponse } from '../models/GetReportResponse';
import type { ListSortDirection } from '../models/ListSortDirection';
import type { ReportSystemDataSource } from '../models/ReportSystemDataSource';
import type { SearchAvailableReportsResponse } from '../models/SearchAvailableReportsResponse';
import type { SearchReportsResponse } from '../models/SearchReportsResponse';
import type { UpdateReportRequest } from '../models/UpdateReportRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ReportsService {
    /**
     * Update a report
     * This endpoint requires the following permissions: [ Reports.Administration.Update.All ]
     * @param id Unique identifier of the created report.
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static updateReportEndpoint(
        id: string,
        requestBody: UpdateReportRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/reports/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Obtain a report by its unique identifier
     * This endpoint requires the following permissions: [  ]
     * @param id Gets or sets the unique identifier of the report to retrieve.
     * @returns GetReportResponse Success
     * @throws ApiError
     */
    public static getReportEndpoint(
        id: string,
    ): CancelablePromise<GetReportResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/reports/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Delete a report
     * This endpoint requires the following permissions: [ Reports.Administration.Delete.All ]
     * @param id The unique identifier of the report to delete.
     * @returns void
     * @throws ApiError
     */
    public static deleteReportEndpoint(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/reports/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Obtains a list of available reports based on the search criteria.
     * This endpoint requires the following permissions: [  ]
     * @param pageNumber Gets or sets the page number.
     * @param pageSize Gets or sets the page size. If not specified, no limit is applied.
     * @param searchTerm Gets or sets the search term used to filter the results.
     * @param sortDirection Specifies the direction (ascending or descending) to sort the items.
     * If null, the default sorting direction is applied.
     * @param ids Collection of report IDs to filter by
     * @param codes Collection of report codes to filter by
     * @param dataSources Collection of data sources to filter by
     * @param categoryIds Collection of category IDs to filter by
     * @param mediaItemIds Collection of media item IDs to filter by
     * @param createDateFrom Filter reports created on or after this date
     * @param createDateTo Filter reports created on or before this date
     * @returns SearchAvailableReportsResponse Success
     * @throws ApiError
     */
    public static searchAvailableReportsEndpoint(
        pageNumber?: number | null,
        pageSize?: number | null,
        searchTerm?: string | null,
        sortDirection?: ListSortDirection | null,
        ids?: Array<string> | null,
        codes?: Array<string> | null,
        dataSources?: Array<ReportSystemDataSource> | null,
        categoryIds?: Array<string> | null,
        mediaItemIds?: Array<string> | null,
        createDateFrom?: string | null,
        createDateTo?: string | null,
    ): CancelablePromise<SearchAvailableReportsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/reports/available',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'searchTerm': searchTerm,
                'sortDirection': sortDirection,
                'ids': ids,
                'codes': codes,
                'dataSources': dataSources,
                'categoryIds': categoryIds,
                'mediaItemIds': mediaItemIds,
                'createDateFrom': createDateFrom,
                'createDateTo': createDateTo,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Obtains a list of reports based on the search criteria.
     * This endpoint requires the following permissions: [ Reports.Administration.View.All ]
     * @param pageNumber Gets or sets the page number.
     * @param pageSize Gets or sets the page size. If not specified, no limit is applied.
     * @param searchTerm Gets or sets the search term used to filter the results.
     * @param sortDirection Specifies the direction (ascending or descending) to sort the items.
     * If null, the default sorting direction is applied.
     * @param ids Collection of report IDs to filter by
     * @param codes Collection of report codes to filter by
     * @param dataSources Collection of data sources to filter by
     * @param categoryIds Collection of category IDs to filter by
     * @param mediaItemIds Collection of media item IDs to filter by
     * @param roleIds Gets or sets the collection of role identifiers
     * that specify access permissions for the report.
     * @param createDateFrom Filter reports created on or after this date
     * @param createDateTo Filter reports created on or before this date
     * @returns SearchReportsResponse Success
     * @throws ApiError
     */
    public static searchReportsEndpoint(
        pageNumber?: number | null,
        pageSize?: number | null,
        searchTerm?: string | null,
        sortDirection?: ListSortDirection | null,
        ids?: Array<string> | null,
        codes?: Array<string> | null,
        dataSources?: Array<ReportSystemDataSource> | null,
        categoryIds?: Array<string> | null,
        mediaItemIds?: Array<string> | null,
        roleIds?: Array<string> | null,
        createDateFrom?: string | null,
        createDateTo?: string | null,
    ): CancelablePromise<SearchReportsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/reports/',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'searchTerm': searchTerm,
                'sortDirection': sortDirection,
                'ids': ids,
                'codes': codes,
                'dataSources': dataSources,
                'categoryIds': categoryIds,
                'mediaItemIds': mediaItemIds,
                'roleIds': roleIds,
                'createDateFrom': createDateFrom,
                'createDateTo': createDateTo,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Create a new report
     * This endpoint requires the following permissions: [ Reports.Administration.Create.All ]
     * @param requestBody
     * @returns CreateReportResponse Success
     * @throws ApiError
     */
    public static createReportEndpoint(
        requestBody: CreateReportRequest,
    ): CancelablePromise<CreateReportResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reports/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Export a report
     * This endpoint requires the following permissions: [  ]
     * @param id Gets or sets the unique identifier of the report.
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static exportReportEndpoint(
        id: string,
        requestBody: ExportReportRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reports/export/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The item has not been found.`,
            },
        });
    }
}
